import { toNamedEntries } from '@client/new/helpers/general';
import { EmptyObject } from '@client/new/helpers/types';
import { utmParams } from '@services/utms';

export const initHubspot = () => {
  const data = utmParams.getFromURL(window.location.search);
  utmParams.store(data);
};

const getHubspotCookie = () =>
  document.cookie.match(/(?:^|; )hubspotutk=([^;]+)/)?.[1] ?? undefined;

const HUBSPOT_SUBMIT_BASE_URL =
  'https://api.hsforms.com/submissions/v3/integration/submit';

export const trackSubmission = <T extends EmptyObject>(p: {
  data: T;
  formId: string;
  portalId: string;
  location?: Location;
  document?: Document;
}) => {
  const loc = p.location ?? window.location;
  const doc = p.document ?? document;

  const fields = toNamedEntries({
    ...p.data,
    ...utmParams.restore(),
  });

  const payload = {
    fields,
    context: {
      pageUri: loc.href,
      pageName: doc.title,
      hutk: getHubspotCookie(),
    },
  };

  return fetch(`${HUBSPOT_SUBMIT_BASE_URL}/${p.portalId}/${p.formId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
};
